const styles = theme => ({
  root: {
    fontFamily: 'Gilroy-Light'
  }
});

export default styles;

